import { render } from "./Square-photo-description-event.vue?vue&type=template&id=bb6869dc&scoped=true"
import script from "./Square-photo-description-event.vue?vue&type=script&lang=js"
export * from "./Square-photo-description-event.vue?vue&type=script&lang=js"

import "./Square-photo-description-event.vue?vue&type=style&index=0&id=bb6869dc&lang=scss&scoped=true"

import exportComponent from "D:\\Projects\\ilustranext\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb6869dc"]])

export default __exports__